import React from 'react';
import i18next from 'i18next';
import OtoButtons from '../common/OtoButtons';

const errorSolutionWrapperStyle = {
  borderBottom: '1px solid #868686',
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'center',
  padding: '5px 0',
  maxWidth: 400,
};

interface IFixErrorStepsProps {
  onLogout: () => void;
}

const FixErrorSteps: React.FC<IFixErrorStepsProps> = (props) => {
  const { onLogout } = props
  return (
    <>
      <p>{i18next.t('fix-error-steps.intro')}</p>
      <div style={errorSolutionWrapperStyle}>
        {i18next.t('fix-error-steps.solution-1-label')}{' '}
        <OtoButtons.ReloadButton onClick={() => window.location.reload()}>
          {i18next.t('fix-error-steps.reload-page')}
        </OtoButtons.ReloadButton>
      </div>
      <div style={errorSolutionWrapperStyle}>
        {i18next.t('fix-error-steps.solution-2-label')}: <OtoButtons.LogoutButton onClick={onLogout} />
      </div>
      <div style={errorSolutionWrapperStyle}>
        {i18next.t('fix-error-steps.solution-3-label')}{' '}
        <OtoButtons.DeleteButton
          color="link"
          onClick={() => {
            sessionStorage.clear();
            localStorage.clear();
            onLogout();
          }}
        >
          {i18next.t('fix-error-steps.clear-cookies')}
        </OtoButtons.DeleteButton>
      </div>
      <p className="mt-2">
        {i18next.t('fix-error-steps.contact-us')}
      </p>
    </>
  );
};

export default FixErrorSteps;
